import { html, PropertyValues } from 'lit';
import { property } from 'lit/decorators.js';
import { BaseWidget } from "./base-widget";

// Info widget implementation.  The contents of info widgets should be loaded from another URL.  
export class InfoWidget extends BaseWidget {
    private _contentUrl: string = '';        // The URL that is used for populating the widget content

    // Begin getters and setters for properties
    get contentUrl(): string {
        return this._contentUrl;
    }

    @property({ type: String })
    set contentUrl(value: string) {
        const oldValue = this._contentUrl;
        this._contentUrl = value;
        this.requestUpdate('contentUrl', oldValue);
    }
    // End getters and setters for properties

    // Overriding content part of the widget.render().  We need landing-page-content-loader to load contents from a URL
    getContentLoaderSlot() {
        return html`
            <div class="widget-content-class">
                <landing-page-content-loader url="${this.contentUrl}" widgetId="${this.widgetId}">landing-page template content</landing-page-content-loader>
            </div>
        `;
    }
    // Widget is loaded, make sure state is maintained
    firstUpdated(changedProperties: PropertyValues) {
        this.showOrHideForState();
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'info-widget': InfoWidget;
    }
}

